import client from "./axios";


const telemetryUrl = `${window.__env.BASE_URL}/telemetry`;


export const Telemetries = {

    saveOrPreviewTelemetry: (telemetry: any, save: boolean = false) => client.put<any>(`${telemetryUrl}?preview=${!save}`, telemetry),

}